<template>
  <div>
    <div v-if="config.ENV == 'development' || NODE_ENV == 'development'" class="temporary" @click="show = true">当前测试版，点击次处临时登录>></div>
    <div v-else class="wx-tip">
      <div class="tip">请使用微信扫描二维码</div>
    </div>
    <el-dialog v-if="show" :visible="show" width="300px" title="临时登录" @close="show = false" append-to-body :close-on-click-modal="false">
      <el-form>
        <el-form-item label="手机号码">
          <el-input v-model="mobile"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false" size="small">取 消</el-button>
        <el-button type="primary" @click="login" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cookie from '@/api/cookie';
export default {
  data() {
    return {
      NODE_ENV: process.env.NODE_ENV,
      show: false,
      mobile: '',
    };
  },

  inject: ['redirectProject', 'getLoginStatus'],

  methods: {
    async login() {
      try {
        let res = await this.api.user.login({ login_name: this.mobile });
        this.loginStatus = 1;
        cookie.setToken(res.data['xx-token']);
        this.$store.commit('user/SET_TOKEN', res.data['xx-token']);
        this.$store.commit('user/SET_LOGIN_STATUS', this.loginStatus);
        this.redirectProject();
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.temporary {
  color: red;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.wx-tip {
  margin-top: 20px;
  text-align: center;
  color: #666;
}
</style>
